import React from "react";
import {
  Box,
  Button,
  ButtonProps,
  Container,
  Header,
  SpaceBetween,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import {
  OmsExportPreset,
  OmsPresetScope,
} from "../../lusca-search-api/generated-src";
import { OmsConfiguration, presetScopeLabel } from "./omsPresetEditing";
import presetChanges from "./omsPresetChanges";

export default function OMSPresetContext({
  preset,
  configuration,
  edited,
  editing,
  name,
  scope,
  disabled,
  onReview,
  onEdit,
  onSaveAsNew,
  onUndo,
  reviewRef,
}: {
  preset: OmsExportPreset;
  configuration: OmsConfiguration;
  edited: boolean;
  editing: boolean;
  name: string;
  scope: OmsPresetScope;
  disabled: boolean;
  onReview: () => void;
  onEdit: () => void;
  onSaveAsNew: () => void;
  onUndo?: () => void;
  reviewRef: React.RefObject<ButtonProps.Ref>;
}) {
  const changes = presetChanges(preset, configuration, name, scope);
  return (
    <section aria-label={editing ? "Preset being edited" : "Applied preset"}>
      <Container
        header={
          !editing ? (
            <Header
              variant="h3"
              actions={
                !disabled && (
                  <SpaceBetween direction="horizontal" size="s">
                    <Button
                      ref={reviewRef}
                      iconName={edited ? undefined : "edit"}
                      onClick={edited ? onReview : onEdit}
                    >
                      {edited ? "Review preset changes" : "Edit preset"}
                    </Button>
                    <Button variant="inline-link" onClick={onSaveAsNew}>
                      Save as new preset
                    </Button>
                  </SpaceBetween>
                )
              }
            >
              Preset: {preset.name}
            </Header>
          ) : undefined
        }
      >
        <SpaceBetween size="xs">
          <div className="oms-preset-context__status">
            <StatusIndicator type={edited ? "warning" : "success"}>
              {edited ? "Unsaved preset changes" : "Saved settings applied"}
            </StatusIndicator>
            <Box color="text-body-secondary">{presetScopeLabel[scope]}</Box>
            {onUndo && (
              <Button variant="inline-link" onClick={onUndo}>
                Undo preset
              </Button>
            )}
          </div>
          {edited && changes.summaries.length > 0 && (
            <Box>{changes.summaries.join(" · ")}</Box>
          )}
          {edited && !editing && (
            <Box color="text-body-secondary">
              These edits apply to this export. Your saved preset changes only
              when you save.
            </Box>
          )}
        </SpaceBetween>
      </Container>
    </section>
  );
}
